// extracted by mini-css-extract-plugin
export var checkbox = "ConfidentialitySettings-module--checkbox--036dc";
export var checkboxContainer = "ConfidentialitySettings-module--checkbox-container--fc5a2";
export var checkboxLabel = "ConfidentialitySettings-module--checkbox-label--60347";
export var checkboxLabelDetails = "ConfidentialitySettings-module--checkbox-label-details--9a3db";
export var checkboxLabelTitle = "ConfidentialitySettings-module--checkbox-label-title--cc97a";
export var container = "ConfidentialitySettings-module--container--37a8c";
export var sentence = "ConfidentialitySettings-module--sentence--c79f4";
export var submitButton = "ConfidentialitySettings-module--submit-button--f0840";
export var title = "ConfidentialitySettings-module--title--13ff0";